/**
 * Typed Redux Hooks
 *
 * Pre-typed hooks for use throughout the application.
 * Use these instead of plain `useDispatch` and `useSelector`.
 */
import { useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

/**
 * Typed dispatch hook - use this instead of plain useDispatch
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

/**
 * Typed selector hook - use this instead of plain useSelector
 */
export const useAppSelector = useSelector.withTypes<RootState>();
